<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Privacy Policy</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row><ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <h1>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> 23 August 2025</p>
        <p><strong>Last Updated:</strong> 23 August 2025</p>

        <p>
          At <strong>Mimbo</strong>, we value your privacy and are committed to
          protecting your personal information. This Privacy Policy explains how
          we collect, use, and safeguard your data when you use our app.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We collect the following types of information:</p>

        <h3>a. Personal Information</h3>
        <ul>
          <li>
            <b>User-Provided Information:</b> First and last names, email
            addresses, usernames and passwords for account creation.
          </li>
          <li>
            <b>Pet Profile Data:</b> If you create a pet profile, we may collect
            your pet's name, breed, age, weight, and medical history.
          </li>
          <li>
            <b>Rescue Center Posts:</b> If you submit a case in the Rescue Center section, your name, email and phone
            number will be displayed
            if you opt-in.
          </li>
        </ul>

        <h3>b. Location Data</h3>
        <ul>
          <li>
            Real-time or user-defined location data for the "Vets Near Me"
            feature.
          </li>
        </ul>

        <h3>c. Optional Data</h3>
        <ul>
          <li>
            Data input by users, such as contact details for rescue center or
            other information added voluntarily.
          </li>
          <li>
            Vaccination dates, medical reminder data, and other related
            information to send notification reminders.
          </li>
          <li>Weight tracking (if introduced in the future).</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Provide and maintain the App’s features.</li>
          <li>
            Send reminders for pet vaccinations, medications, and appointments.
          </li>
          <li>
            Facilitate the "Vets Near Me" feature using real-time or custom
            location data.
          </li>
          <li>
            Facilitate the Rescue Center section by displaying user-provided
            contact details.
          </li>
          <li>
            Display names, email addresses and phone numbers in rescue center
            posts when users add new cases (with user confirmation).
          </li>
        </ul>

        <h2>3. Data Sharing</h2>
        <p>
          We do not sell or share your personal data with third parties.
          However:
        </p>
        <ul>
          <li>
            Names and email addresses are displayed in rescue center posts when
            a user adds a new case. Users must confirm this via a checkbox.
          </li>
          <li>Pet pictures in Pawstagram are visible to all users.</li>
          <li>We use Firebase for hosting images and sending notifications.</li>
          <li>
            Any donation-related transactions are conducted directly through
            external NGO websites, and we do not process or store any financial
            information.
          </li>
        </ul>

        <h2>4. Data Retention</h2>
        <p>
          We retain your data until you delete your account. Once an account is
          deleted, all associated data is permanently removed from our servers.
        </p>

        <h2>5. Data Security</h2>
        <p>We take reasonable measures to protect your data, including:</p>
        <ul>
          <li>Passwords are encrypted before storage.</li>
          <li>Only authorized personnel can access sensitive data.</li>
        </ul>
        <p>
          However, please note that other data, apart from passwords, is not
          encrypted.
        </p>

        <h2>6. User Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access and update your data through the app.</li>
          <li>Delete your account, which will erase all associated data.</li>
          <li>
            You can disable location services through your device settings.
          </li>
        </ul>

        <h2>7. Children’s Privacy</h2>
        <p>
          Our app targets pet owners and is not specifically designed for
          children under 13. We do not knowingly collect data from children
          under this age.
        </p>

        <h2>8. Third-Party Services</h2>
        <ul>
          <li>We use Firebase for hosting images and notifications.</li>
          <li>
            Donation links redirect users to NGO websites, and we are not
            responsible for their privacy practices. Review their privacy
            policies before sharing information.
          </li>
        </ul>

        <h2>9. Embedded Content</h2>
        <p>
          Our app includes embedded YouTube videos that are exclusively
          pet-related. YouTube's privacy policies apply to content accessed
          through these videos.
        </p>

        <h2>10. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Significant
          changes will be communicated to you through the app. The "Effective
          Date" at the top of this page indicates when this policy was last
          updated.
        </p>

        <h2>11. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy, please
          contact us at:
        </p>
        <p>
          <strong>Email:</strong>
          adminsupport&#64;mimboapp.com
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>